/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ProfileHeaderData_tradeFirm = {
    readonly name: string | null;
    readonly " $fragmentRefs": FragmentRefs<"ProfileLocation_tradeFirm" | "ProfileTabs_tradeFirm" | "ProfileContactInfo_tradeFirm" | "ProfileIcon_tradeFirm">;
    readonly " $refType": "ProfileHeaderData_tradeFirm";
};
export type ProfileHeaderData_tradeFirm$data = ProfileHeaderData_tradeFirm;
export type ProfileHeaderData_tradeFirm$key = {
    readonly " $data"?: ProfileHeaderData_tradeFirm$data;
    readonly " $fragmentRefs": FragmentRefs<"ProfileHeaderData_tradeFirm">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProfileHeaderData_tradeFirm",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProfileLocation_tradeFirm"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProfileTabs_tradeFirm"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProfileContactInfo_tradeFirm"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProfileIcon_tradeFirm"
    }
  ],
  "type": "TradeFirmType",
  "abstractKey": null
};
(node as any).hash = 'e93e1973f01f0d18ce51149edf9fcdeb';
export default node;
